import React, { ReactChild, FC } from 'react'
import { createStyles, Dialog, AppBar, Toolbar, IconButton, Typography, Button, CircularProgress, Theme, makeStyles, Box } from '@material-ui/core'
import { ValidatorForm } from 'react-material-ui-form-validator'


export interface FormDialogProps {
    open: boolean
    title?: string
    buttonContent?: string | ReactChild
    onCloseButtonClick?: () => void
    onSubmit?: () => void
    loading?: boolean;
    dialog?: boolean;
}

const FormDialog: FC<FormDialogProps> = (props) => {

    const handleCloseButtonClicked = () => {
        if (props.onCloseButtonClick) {
            props.onCloseButtonClick();
        }
    }

    const handleSubmit = () => {
        if (props.onSubmit) {
            props.onSubmit();
        }
    }

    const handleError = (error: any[]) => {
        console.log("Error", error);
    }

    const classes = useStyles();
    const { title, buttonContent = 'SAVE', loading = false, open, dialog = true } = props;

    const Wrapper = dialog ? Dialog : Box


    return (
        open ?
            <Wrapper
                open={open}
                classes={dialog ? { paper: classes.dialog } : { root: classes.root }}
                fullScreen
                children={
                    <ValidatorForm onSubmit={handleSubmit} onError={handleError} >
                        <AppBar position={'static'} color='secondary' >
                            <Toolbar className={classes.toolbar} >
                                <IconButton color='inherit' onClick={handleCloseButtonClicked}><i className='material-icons'>close</i></IconButton>
                                {title ? <Typography color='inherit' variant='h6' >{title}</Typography> : null}
                                <Button variant={'outlined'} type={'submit'} color='inherit' disabled={loading} >
                                    {
                                        loading
                                            ?
                                            <CircularProgress color='primary' size={26} thickness={5} />
                                            :
                                            buttonContent
                                    }
                                </Button>
                            </Toolbar>
                        </AppBar>
                        <div className={classes.formContainer} >
                            {props.children}
                        </div>
                    </ValidatorForm>
                }
            />
            : null
    )
}

const useStyles = makeStyles((theme: Theme) => createStyles({
    root: {
        width: '100%',
        // position: 'fixed',
        // left: 0, right: 0, bottom: 0, top: 0
    },
    dialog: {
        // paddingTop: 64
    },
    toolbar: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    formContainer: {
        margin: 50,
        display: 'flex',
        justifyContent: 'center'
    }
}))

export default FormDialog;